// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".coupon-dia .van-popup{background-color:#f8f8f8}.coupon-dia .van-tabs__nav{background-color:#f8f8f8!important}", ""]);
// Exports
module.exports = exports;
